import React, { useEffect, useRef, useState } from "react";
import cn from "classnames";
import style from "./style.module.scss";
import OrdersLocationDropdown from "./OrdersLocationDropdown";
import { useClickOutside } from "../../../hooks/useClickOutside";
import { t } from "i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const OrdersLocationInfo = ({
  isSender = false,
  isRailway = false,
  isIntermediatePoint = false,
  isEditable = false,
  isRecipientLatLng = false,
  forceOpenDropdown = false,
  forceOpenDropdownCount = 0,
  address = "",
  onChangeAddress,
  onChangeResipient,
  countrySelected,
  citySelected,
  onRecipientPhone,
  onChangeCity,
  onChangeCountry,
  companyName = "",
  labelText = "",
  errorText = "",
  phoneNumber,
  countries = [],
  detect,
  onCoordinates,
  onAddressId,
  onRecipientEmail,
}) => {
  const [displayModal, changeDisplayModal] = useState(false);
  const infoRef = useRef(null);
  const iconColor = isEditable ? "" : "-color";
  const company = useSelector((state) => state.user.company);

  if (isEditable) {
    useClickOutside(infoRef, () => changeDisplayModal(false));
  }

  const clickHandle = (obj) => {
    if (onChangeAddress) {
      onChangeAddress(obj.fullAddress);
    }
    if (onChangeResipient) {
      onChangeResipient(obj?.name);
    }
    if (onRecipientPhone) {
      onRecipientPhone(obj?.phoneNumber);
    }
    if (onCoordinates) {
      onCoordinates(obj?.latLng);
    }
    if (onAddressId) {
      onAddressId(obj?.id);
    }
    if (onRecipientEmail) {
      onRecipientEmail(obj?.email);
    }
    changeDisplayModal(false);
    if (detect) detect();
  };

  return (
    <>
      <div
        ref={infoRef}
        className={cn(style.wrapper, { [style.errorState]: errorText })}
        onClick={() => {
          if (!isEditable) return;
          if (!countrySelected || !citySelected) {
            toast.info(t("addressOrder.selectCountryFirst"));
            return;
          }
          changeDisplayModal(!displayModal);
        }}
      >
        <label className={cn(style.labelInp, { [style.labelError]: errorText })}>{labelText}</label>
        <img src={"/icons/" + (isSender ? "sender" : "location") + iconColor + ".svg"} alt="icon" />
        <div className={style.content}>
          {isEditable && !address ? (
            <div>{t("carsCreatePage.vehicleType.placeholder")} {isSender ?  t("addressOrder.sender")  : t("addressOrder.recipient")}</div>
          ) : (
            <>
              {<h4>{companyName ? companyName : company?.name}</h4>}
              <p>{address}</p>
            </>
          )}
        </div>
        {displayModal && (
          <OrdersLocationDropdown
            isRailway={isRailway}
            onClose={() => changeDisplayModal(false)}
            isSender={isSender}
            isIntermediatePoint={isIntermediatePoint}
            countries={countries}
            clickHandle={clickHandle}
            countrySelected={countrySelected}
            citySelected={citySelected}
            onChangeCountry={onChangeCountry}
            onChangeCity={onChangeCity}
          />
        )}
      </div>
      {errorText && <div className={style.errorText}>{errorText}</div>}
    </>
  );
};

export default OrdersLocationInfo;
